import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, HostListener } from '@angular/core';
let NgDocCheckedChangeDirective = /*#__PURE__*/(() => {
  class NgDocCheckedChangeDirective {
    set ngDocChecked(checked) {
      this.updateProperty('checked', checked || false);
      this.updateProperty('indeterminate', checked === null);
    }
    constructor(element, renderer) {
      this.element = element;
      this.renderer = renderer;
      this.ngDocCheckedChange = new EventEmitter();
      this.updateProperty('checked', false);
    }
    onChange({
      checked
    }) {
      this.updateProperty('indeterminate', false);
      this.ngDocCheckedChange.emit(checked);
    }
    updateProperty(property, value) {
      this.renderer.setProperty(this.element.nativeElement, property, value);
    }
    static {
      this.ɵfac = function NgDocCheckedChangeDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocCheckedChangeDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgDocCheckedChangeDirective,
        selectors: [["input", "ngDocChecked", ""], ["input", "ngDocCheckedChange", ""]],
        hostBindings: function NgDocCheckedChangeDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("change", function NgDocCheckedChangeDirective_change_HostBindingHandler($event) {
              return ctx.onChange($event.target);
            });
          }
        },
        inputs: {
          ngDocChecked: "ngDocChecked"
        },
        outputs: {
          ngDocCheckedChange: "ngDocCheckedChange"
        }
      });
    }
  }
  return NgDocCheckedChangeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocCheckedChangeDirective };
